import { connect } from 'react-redux';
import Dropdown from '../../components/sections/Dropdown';
import { updateImportPopup } from '../../actions';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => {
  return {
    updateImportPopupOpen: value => {
      dispatch(updateImportPopup(value));
    },
  };
};

const DropdownRedux = connect(mapStateToProps, mapDispatchToProps)(Dropdown);

export default DropdownRedux;
